import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserDetailsResponse, UserSummaryResponse } from '../../../interfaces/response/UserResponses';
import { AssignStoresToUserRequest } from '../../../interfaces/request/UserRequests';
import { UserSummary } from '../../../classes/models/user/UserSummary';
import { UserDetailsAdapter, UserSummaryAdapter } from '../../../classes/adapters/response/user/UserAdapter';
import { UserDetails } from '../../../classes/models/user/UserDetails';

/**
 * This service communicates with backend to retrieve and manage user data.
 */
@Injectable({
  providedIn: 'root'
})
export class UserService {
  private http = inject(HttpClient);
  private userSummaryAdapter = inject(UserSummaryAdapter);
  private userDetailsAdapter = inject(UserDetailsAdapter);

  url = environment.apiUrl + '/users';

  /**
   * Retrieves a list of all users.
   */
  getUserSummaries(): Observable<UserSummary[]> {
    return this.http.get(this.url).pipe(
      map((data: UserSummaryResponse[]) => this.userSummaryAdapter.adapt(data)));
  }

  /**
   * Retrieves detailed information about a user.
   * @param userEmail an email of a user.
   */
  getUserDetails(userEmail: string): Observable<UserDetails> {
    const url = `${this.url}/${userEmail}`;
    return this.http.get(url).pipe(
      map((data: UserDetailsResponse) => this.userDetailsAdapter.adapt(data)));
  }

  /**
   * Assigns store to be accessible by the user.
   * @param userEmail an email of a user.
   * @param assignedStores a list of store identifiers, to which the user will be assigned.
   */
  assignUserStores(userEmail: string, assignedStores: string[]) {
    const url = `${this.url}/${userEmail}`;
    const request: AssignStoresToUserRequest = { stores: assignedStores };
    return this.http.patch(url, request);
  }
}
